
// import React, { useEffect, useRef, useState } from "react";
// import {
//   FaRocket,
//   FaLeaf,
//   FaLightbulb,
// } from "react-icons/fa";

// import "./Initiative.css";

// const initiativesData = [
//   {
//     id: 1,
//     badge: "INITIATIVE 1 OF 4",
//     image: "https://startupmahakumbh.org/assets/img/hero-carousel/lightingA.jpg",
//     icon: <FaRocket />,
//     title: "Startup Mahakumbh",
//     description:
//       "India's largest startup ecosystem gathering bringing together entrepreneurs, investors, and innovators from across the country.",
//     brochureUrl: null,
//   },
//   {
//     id: 2,
//     badge: "INITIATIVE 2 OF 4",
//     image: "https://www.assocham.org/assets/images/1726475433_7.jpg",
//     icon: <FaLeaf />,
//     title: "GEM Green Building Certification Program",
//     description:
//       "Promoting sustainable architecture and eco-friendly infrastructure through certifications and green development programs.",
//     brochureUrl: null,
//   },
//   {
//     id: 3,
//     badge: "INITIATIVE 3 OF 4",
//     image: "https://assochamipr.in/wp-content/uploads/2021/11/assocham-1-1.jpg",
//     icon: <FaLightbulb />,
//     title: "Intellectual Property Facilitation Centre",
//     description:
//       "Helping innovators and businesses protect their intellectual property with expert legal and strategic guidance.",
//     brochureUrl: null,
//   },
//   {
//     id: 4,
//     badge: "INITIATIVE 4 OF 4",
//     image: "https://www.assocham.org/assets/images/banner/foundation-banner.jpeg",
//     icon: <FaLightbulb />,
//     title: "ASSOCHAM Foundation for Corporate Social Responsibility",
//     description:
//       "ASSOCHAM Foundation for CSR - Driving impactful corporate social responsibility initiatives across India for sustainable development and social welfare.",
//     brochureUrl: "https://www.assocham.org/uploads/AFCSR_Brochure_2026.pdf", // Replace with actual PDF URL if different
//   },
// ];

// const Initiative = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [isPaused, setIsPaused] = useState(false);

//   const intervalRef = useRef(null);

//   useEffect(() => {
//     if (!isPaused) {
//       intervalRef.current = setInterval(() => {
//         setActiveIndex((prev) =>
//           prev === initiativesData.length - 1 ? 0 : prev + 1
//         );
//       }, 5000);
//     }

//     return () => clearInterval(intervalRef.current);
//   }, [isPaused]);

//   const activeInitiative = initiativesData[activeIndex];

//   const handleBrochureClick = () => {
//     if (activeInitiative.brochureUrl) {
//       window.open(activeInitiative.brochureUrl, "_blank");
//     }
//   };

//   return (
//     <div
//       className="initiative-container"
//       onMouseEnter={() => setIsPaused(true)}
//       onMouseLeave={() => setIsPaused(false)}
//     >
//       <div className="initiative-card">
//         {/* IMAGE */}
//         <div className="image-wrapper">
//           <img
//             src={activeInitiative.image}
//             alt={activeInitiative.title}
//             className="initiative-image"
//           />
//         </div>

//         {/* CONTENT */}
//         <div className="content-section">
//           <div className="title-row">
//             <span className="initiative-icon">
//               {activeInitiative.icon}
//             </span>
//             <h2>{activeInitiative.title}</h2>
//           </div>

//           <p className="description">
//             {activeInitiative.description}
//             <br />
//             <a href="#" className="view-more-text">
//               View More →
//             </a>

//             {/* AFCSR Brochure Button - Only shows for AFCSR */}
//           {activeInitiative.brochureUrl && (
//             <div className="brochure-section">
//               <button 
//                 onClick={handleBrochureClick}
//                 className="brochure-btn"
//               >
//                 📄 AFCSR Brochure
//               </button>
//             </div>
//           )}
//           </p>

          

//           {/* SWITCH OPTIONS */}
//           <div className="switch-options">
//             {initiativesData.map((item, index) => (
//               <button
//                 key={item.id}
//                 onClick={() => setActiveIndex(index)}
//                 className={`switch-btn ${activeIndex === index ? "active" : ""}`}
//               >
//                 {item.title}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Initiative;




// new new code 




import React, { useEffect, useRef, useState } from "react";
import {
  FaRocket,
  FaLeaf,
  FaLightbulb,
} from "react-icons/fa";

import "./Initiative.css";

const initiativesData = [
  {
    id: 1,
    badge: "INITIATIVE 1 OF 4",
    image: "https://startupmahakumbh.org/assets/img/hero-carousel/lightingA.jpg",
    icon: <FaRocket />,
    title: "Startup Mahakumbh",
    description:
      "The second edition of Startup Mahakumbh concluded on a high note at Bharat Mandapam, New Delhi, from April 3 to 5, 2025. Led by FICCI, ASSOCHAM, NASSCOM, TiE, IVCA, and Bootstrap Foundation, with support from DPIIT, GeM (Presenting Partner), and SIDBI & ECGC (Powered by Partners), the event marked a major milestone in India’s startup journey.",
    pageUrl: "https://startupmahakumbh.org/", // Redirect link for this initiative
    brochureUrl: null,
  },
  {
    id: 2,
    badge: "INITIATIVE 2 OF 4",
    image: "https://www.assocham.org/assets/images/1726475433_7.jpg",
    icon: <FaLeaf />,
    title: "GEM Green Building Certification Program",
    description:
      "ASSOCHAM initiated its endeavour of value creation for Indian industry in 1920. Having in its fold more than 400 Chambers and Trade Associations, and serving more than 4,50,000 members from all over India. It has witnessed upswings as well as upheavals of Indian Economy, and contributed significantly by playing a catalytic role in shaping up the Trade, Commerce and Industrial environment of the country.",
    pageUrl: "https://www.green-assocham.com/", // Redirect link for this initiative
    brochureUrl: null,
  },
  {
    id: 3,
    badge: "INITIATIVE 3 OF 4",
    image: "https://assochamipr.in/wp-content/uploads/2021/11/assocham-1-1.jpg",
    icon: <FaLightbulb />,
    title: "Intellectual Property Facilitation Centre",
    description:
      "The Intellectual Property Rights (IPR) Council at ASSOCHAM is intensively involved with issues pertaining to the protection and enforcement of Intellectual Property Rights. The Council is actively engaged in creating awareness about the importance of IPR and its role in promoting innovation and creativity. It also provides guidance and support to businesses and individuals in protecting their intellectual property assets.",
    pageUrl: "https://assochamipr.in/", // Redirect link for this initiative
    brochureUrl: null,
  },
  {
    id: 4,
    badge: "INITIATIVE 4 OF 4",
    image: "https://www.assocham.org/assets/images/banner/foundation-banner.jpeg",
    icon: <FaLightbulb />,
    title: "ASSOCHAM Foundation for Corporate Social Responsibility",
    description:
      "Rooted in the legacy of ASSOCHAM, India’s apex industry chamber, the ASSOCHAM Foundation for Corporate Social Responsibility (AFCSR) was established as a Trust in 2013 to bridge the gap between policy and grassroots action— delivering impactful programs in partnership with corporates, government bodies, and communities. AFCSR is dedicated to identifying social, developmental, and environmental challenges that require urgent attention, measurable outcomes, and sustainable solutions.",
    pageUrl: null, // No redirect for AFCSR - uses brochure download instead
    brochureUrl: "https://www.assocham.org/uploads/AFCSR_Brochure_2026.pdf", // Replace with actual PDF URL if different
  },
];

const Initiative = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setActiveIndex((prev) =>
          prev === initiativesData.length - 1 ? 0 : prev + 1
        );
      }, 5000);
    }

    return () => clearInterval(intervalRef.current);
  }, [isPaused]);

  const activeInitiative = initiativesData[activeIndex];

  const handleBrochureClick = () => {
    if (activeInitiative.brochureUrl) {
      window.open(activeInitiative.brochureUrl, "_blank");
    }
  };

  return (
    <div
      className="initiative-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="initiative-card">
        {/* IMAGE */}
        <div className="image-wrapper">
          <img
            src={activeInitiative.image}
            alt={activeInitiative.title}
            className="initiative-image"
          />
        </div>

        {/* CONTENT */}
        <div className="content-section">
          <div className="title-row">
            <span className="initiative-icon">
              {activeInitiative.icon}
            </span>
            <h2>{activeInitiative.title}</h2>
          </div>

          <p className="description">
            {activeInitiative.description}
          </p>

          {/* READ MORE / BROCHURE SECTION */}
          <div className="action-row">
            {activeInitiative.brochureUrl ? (
              // AFCSR - Only brochure download, no page redirect
              <button
                onClick={handleBrochureClick}
                className="brochure-btn"
              >
                📄 AFCSR Brochure
              </button>
            ) : (
              // Other initiatives - Read More redirects to their page
              <a href={activeInitiative.pageUrl} className="view-more-text">
                View More →
              </a>
            )}
          </div>

          {/* SWITCH OPTIONS */}
          <div className="switch-options">
            {initiativesData.map((item, index) => (
              <button
                key={item.id}
                onClick={() => setActiveIndex(index)}
                className={`switch-btn ${activeIndex === index ? "active" : ""}`}
              >
                {item.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Initiative;